var map = {
	"./ar.json": 92993,
	"./de.json": 84589,
	"./el.json": 98919,
	"./en.json": 99265,
	"./es.json": 56898,
	"./fr.json": 58746,
	"./hi.json": 67693,
	"./it.json": 61891,
	"./nl.json": 24276,
	"./pt.json": 81966,
	"./tr.json": 48140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;